import { memo } from "react";

import OwnerAnimalSelect from "../../components/multiforms/OwnerAnimalSelect";

const SelectAnimal = () => {
    return (
        <OwnerAnimalSelect type={"SelectAnimal"} />
    )
};

export default memo(SelectAnimal)